import { Styles } from "./styled";

import { FC } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import useAppFormInformation, { ReceivedProps } from "./hook";

import { useConfirmingLeave } from "@lhd/app/index";
import InputAreaField from "@lhd/components/FormField/InputAreaField";
import InputField from "@lhd/components/FormField/InputField";
import SelectField from "@lhd/components/FormField/SelectField";
import { Button as ButtonAnt, Form, notification, Radio, Upload } from "antd";
import { FormikProvider } from "formik";
import { IoCloseOutline, IoTrashOutline } from "react-icons/io5";
import { UploadOutlined } from "@ant-design/icons";
import ModalSelectIcon from "@lhd/features/AppCategories/AppCategoriesControl/components/ModalSelectIcon";

const ButtonUploadThumnail = () => (
  <div>
    <AiOutlinePlus />
    <div style={{ marginTop: 8 }}>
      <span className="common-font-size">Bizシート画像登録</span>
    </div>
  </div>
);

export const ListColorPicker = [
  "#EF4444",
  "#F97316",
  "#D946EF",
  "#EC4899",
  "#FACC15",
  "#4ADE80",
  "#2DD4BF",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
];

const AppFormInformation: FC<ReceivedProps> = (props) => {
  const {
    imageUrl,
    handleUrl,
    setImageUrl,
    handleUploadThumbnail,
    thumbnailList,
    handleDeleteThumbnail,
    categoriesApp,
    // handleDeletePicture,
    handleChangeTypeUpload,
    typeUpload,
    selectedImage,
    handleOpenModalSelectIcon,
    imageName,
    isOpenModalSelectIcon,
    handleCloseModalSelectIcon,
    imagePaths,
    handleOkModalSelect,
    displaySize,
    height,
    size,
    isNameRequiredError,
  } = useAppFormInformation(props);

  const formik = props.form;
  const { setFieldValue, values } = formik;

  const {
    checkLeaveForm,
    // confirmingState,
    // setConfirmingState,
    // setCallbackEvent,
  } = useConfirmingLeave();

  const { getFieldClassName, registerFormWatcher } = props;

  return (
    <Styles text_scale={displaySize} isNameRequiredError={isNameRequiredError}>
      <FormikProvider value={formik}>
        <Form
          {...(registerFormWatcher && registerFormWatcher())}
          layout="vertical"
          autoComplete="off"
          labelAlign="left"
          labelWrap
        >
          <div className="container">
            <div className="left-box">
              <InputField
                isLeaveForm
                name="name"
                label="Bizシート名"
                required
                setFieldValue={setFieldValue}
                className={`${getFieldClassName && getFieldClassName("name")}`}
              />
              <p className="common-font-size">Bizシートロゴ</p>
              <Radio
                checked={typeUpload === "icon"}
                value="icon"
                onChange={(e) => {
                  handleChangeTypeUpload(e?.target?.value);
                  setFieldValue("typeUpload", e?.target?.value);
                }}
              >
                アイコン選択
              </Radio>
              <div className="wrap-list-icon-app">
                <img
                  className={`${typeUpload === "icon" ? "" : "disable"}`}
                  src={selectedImage}
                  alt=""
                  onClick={handleOpenModalSelectIcon}
                />
              </div>

              <Radio
                className="mt-1"
                checked={typeUpload === "file"}
                value="file"
                onChange={(e) => {
                  handleChangeTypeUpload(e?.target?.value);
                  setFieldValue("typeUpload", e?.target?.value);
                }}
              >
                画像アプロード
              </Radio>

              <div className="d-flex mt-1">
                <Upload
                  name="picture"
                  maxCount={1}
                  showUploadList={false}
                  customRequest={undefined}
                  disabled={imageUrl || typeUpload !== "file"}
                  accept=".jpg,.jpeg,.png,.gif"
                  beforeUpload={(file) => {
                    const isImage = file.type.startsWith("image/");
                    if (!isImage) {
                      notification["error"]({
                        message: "画像ファイルのみアップロード可能です。",
                      });

                      return false;
                    }

                    const isLessThan200KB = file.size / 1024 < 200;
                    if (!isLessThan200KB) {
                      notification["error"]({
                        message: "ファイルサイズは200KB以下にしてください。",
                      });

                      return false;
                    }

                    setImageUrl(file);
                    setFieldValue("picture", file);
                    checkLeaveForm();
                    return false;
                  }}
                >
                  <ButtonAnt
                    disabled={imageUrl || typeUpload !== "file"}
                    icon={
                      <div className="flex-center">
                        <UploadOutlined />
                      </div>
                    }
                    style={{
                      fontSize: size,
                      height: height,
                      width: "fit-content",
                      gap: 5,
                      padding: "0px 5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    アイコンアップロード
                  </ButtonAnt>
                </Upload>
                {imageUrl && (
                  <div
                    className={`wrap-icon-app ${
                      typeUpload !== "file" ? "disable" : ""
                    }`}
                  >
                    <div className="d-flex">
                      <img className="icon-app" src={handleUrl(imageUrl)} />
                      <span>{imageName}</span>
                    </div>
                    <div
                      className="icon-delete"
                      onClick={() => {
                        setImageUrl(null);
                        setFieldValue("picture", null);
                      }}
                    >
                      <IoTrashOutline size={18} />
                    </div>
                  </div>
                )}
              </div>

              <span className="upload-description">
                最大アプロードのサイズ：200KB
              </span>
              {/* {imageUrl ? (
                <div className="wrap-picture">
                  <img
                    src={handleUrl(imageUrl)}
                    alt="picture"
                    style={{ width: "100%" }}
                  />
                  <div
                    className="wrap-icon-delete"
                    onClick={handleDeletePicture}
                  >
                    <IoCloseOutline size={18} color="#fff" />
                  </div>
                </div>
              ) : (
                <Upload
                  name="picture"
                  listType="picture-card"
                  maxCount={1}
                  showUploadList={false}
                  beforeUpload={(e) => {
                    setImageUrl(e);
                    setFieldValue("picture", e);
                    checkLeaveForm();
                    return false;
                  }}
                >
                  <ButtonUploadApp />
                </Upload>
              )} */}

              <SelectField
                isLeaveForm
                options={categoriesApp}
                name="categories"
                label="カテゴリ選択"
                required
                className={`mt-1 ${
                  getFieldClassName && getFieldClassName("categories")
                }`}
                multiple
                setFieldValue={setFieldValue}
              />

              <InputAreaField
                isLeaveForm
                className="no-mb"
                name="description"
                label="説明文"
                setFieldValue={setFieldValue}
              />
            </div>
            <div className="right-box">
              <p className="mb-1 common-font-size">Bizシート画像アプロード</p>
              <div className="wrap-thumbnail-list ">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="upload-thumbnail"
                  showUploadList={false}
                  beforeUpload={handleUploadThumbnail}
                  // beforeUpload={() => false}
                  multiple
                >
                  <ButtonUploadThumnail />
                </Upload>

                {thumbnailList.map((file) => (
                  <div key={file?.uid} className="wrap-thumbnail-item">
                    <img
                      className="thumbnail-item"
                      src={handleUrl(file)}
                      alt={file?.name}
                    />
                    <div
                      className="wrap-icon-delete"
                      onClick={() => handleDeleteThumbnail(file?.uid)}
                    >
                      <IoCloseOutline size={18} color="#fff" />
                    </div>
                  </div>
                ))}
              </div>
              <p className="mb-1 mt-2 d-flex common-font-size">
                <span className="icon-required ">*</span>
                Bizシートカラー
                {values?.hex_color && (
                  <div
                    className="wrap-background-color-picked"
                    style={{
                      borderColor: values?.hex_color,
                    }}
                  >
                    <div
                      className="background-color-picked"
                      style={{
                        backgroundColor: values?.hex_color,
                      }}
                    />
                  </div>
                )}
              </p>
              <div className="wrap-color-picker">
                {ListColorPicker.map((backgroundColor: string) => (
                  <div
                    key={backgroundColor}
                    className={`color-picker-item ${
                      values?.hex_color === backgroundColor && "active"
                    }`}
                    onClick={() => setFieldValue("hex_color", backgroundColor)}
                  >
                    <div
                      className="color-picker-background"
                      style={{ backgroundColor }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Form>

        <ModalSelectIcon
          isOpen={isOpenModalSelectIcon}
          onCancel={handleCloseModalSelectIcon}
          onOk={(pathItem: string) => {
            handleOkModalSelect(pathItem);
          }}
          imagePaths={imagePaths}
          selectedImage={selectedImage}
        />
      </FormikProvider>
    </Styles>
  );
};

export default AppFormInformation;
